import * as _ from 'underscore';
import { SiteRolePickerMenu } from '../../common/react/components/SiteRolePickerMenu';
import { SiteRoleOption, SiteRoleOptionsResource, UnlicensedTier } from '../resources/SiteRoleOptions';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { ServerService } from '../services/ServerService';

export interface ISiteRolePickerMenuScope extends ng.IScope {
  shouldShowLicensingTierInfo: boolean;
  siteRoleSelectorProps: SiteRolePickerMenu.Props;
}

export class SiteRolePickerMenuHelper {

  public static setupPickerMenuScope(
    scope: ISiteRolePickerMenuScope,
    $translate: ng.translate.ITranslateService,
    server: ServerService,
    siteRoleOptionsResource: SiteRoleOptionsResource,
    selectedRole: string,
    onSiteRoleSelected: (roleOption: SiteRoleOption) => void,
    excludeServerAdmin: boolean = false
  ): void {
    scope.shouldShowLicensingTierInfo = server.shouldShowServerLicensingTierInfo();

    const roleOptions =
      excludeServerAdmin === true ? siteRoleOptionsResource.getAllSiteRoleOptionsExcept(SiteRoles.ServerAdministrator) : siteRoleOptionsResource.getAllSiteRoleOptions();

    scope.siteRoleSelectorProps = <SiteRolePickerMenu.Props> {
      translate: $translate.instant,
      siteRoleOptions: roleOptions,
      getSiteRoleOptionBySiteRole: (siteRole: string) => siteRoleOptionsResource.getSiteRoleOptionBySiteRole(siteRole),
      selectedRole: siteRoleOptionsResource.getSiteRoleOptionBySiteRole(selectedRole),
      onOptionSelected: onSiteRoleSelected
    };
  }

  public static setScopeToDisableAllLicensedRolesIfOutOfQuota(scope: ISiteRolePickerMenuScope & { availableQuota: number }) {
    const disableAllExceptUnlicensed = (option: SiteRoleOption) => scope.availableQuota <= 0 && option.licenseTierRole !== UnlicensedTier;
    SiteRolePickerMenuHelper.updatePickerMenuDropdownOptionDisabledStates(scope, disableAllExceptUnlicensed);
  }

  public static updatePickerMenuDropdownOptionDisabledStates(
    scope: ISiteRolePickerMenuScope,
    shouldDisableOption: (option: SiteRoleOption) => boolean
  ): void {
    scope.siteRoleSelectorProps.disabledRoleOptions = _.filter(scope.siteRoleSelectorProps.siteRoleOptions, shouldDisableOption);
  }

  public static getPickerMenuDropdownOptionDisabledOptions(availableQuota: number, siteRoleOptions: ReadonlyArray<SiteRoleOption>): ReadonlyArray<SiteRoleOption> {
    const disableAllExceptUnlicensed = (option: SiteRoleOption) => availableQuota <= 0 && option.licenseTierRole !== UnlicensedTier;
    return _.filter(siteRoleOptions, disableAllExceptUnlicensed);
  }
}

